module.exports = __webpack_public_path__ + "static/media/bullet.57a4f12e.svg";